<template>
	<v-container fluid>
		<div v-if="!loading">
			<div v-if="channelsSales">
				<v-row class="total secondary--text">
					Sales by channels (units)
				</v-row>
				<!--table head-->
				<v-row class="total mt-8" no-gutters>
					<v-col cols="2" class="tabCell text-left">Products</v-col>
					<v-col v-for="chan in selfChannels"
						:key="chan.id"
						class="tabCell text-right">{{ chan.name }}
					</v-col>
					<v-col v-for="chan in independentChains"
						:key="chan.id"
						class="tabCell text-right">{{ chan.name }}
					</v-col>
					<v-col class="tabCell text-right">Total (year)</v-col>
				</v-row>
				<!--table content-->
				<v-expansion-panels multiple v-model="panel">
					<v-expansion-panel
						v-for="brand in prevProducts"
						:key="brand.id"
					>
						<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
							{{ brand.trademark }}
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<div v-for="model in sortedModels(brand.models)" :key="model.id">
							<v-row no-gutters><!--units-->
								<v-col cols="2" class="tabCell text-left">{{ name(model.model) }}</v-col>
								<v-col v-for="chan in selfChannels"
									:key="chan.id"
									class="tabCell text-right">
									{{ format(modelSales(chan, model))}}
								</v-col>
								<v-col v-for="chain in independentChains"
									:key="chain.id"
									class="tabCell text-right">
								{{ format(modelSales(chain, model))}}
								</v-col>
								<v-col class="tabCell text-right total">{{format(yearSales(model))}}</v-col>
							</v-row>
						</div>
						<!--total trademark sales-->
						<v-row v-if="brand.models.length > 1" class="total" no-gutters>
							<v-col cols="2" class="tabCell text-left">Total by {{brand.trademark}} (units)</v-col>
							<v-col v-for="chan in selfChannels"
								:key="chan.id"
								class="tabCell text-right">
								{{ format(trademarkSales(brand.trademark, chan))}}
							</v-col>
							<v-col v-for="chain in independentChains"
								:key="chain.id"
								class="tabCell text-right">
								{{ format(trademarkSales(brand.trademark, chain))}}
							</v-col>
							<v-col class="tabCell text-right">{{format(yearTrademarkSales(brand.trademark))}}</v-col>
						</v-row>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
				<!--total sales-->
				<v-row class="total px-5" no-gutters>
					<v-col cols="2" class="tabCell text-left">Total by channel (units)</v-col>
					<v-col v-for="chan in selfChannels"
						:key="chan.id"
						class="tabCell text-right">
						{{ format(channelSales (chan))}}
					</v-col>
					<v-col v-for="chain in independentChains"
						:key="chain.id"
						class="tabCell text-right">
						{{ format(channelSales (chain))}}
					</v-col>
					<v-col class="tabCell text-right">{{format(yearChannelsSales())}}</v-col>
				</v-row>
			</div>
			<div v-else>
				<v-row class="total" justify="center">
					Select the round & press the button "load", please
				</v-row>
			</div>
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
	import numeral from 'numeral'
	import Loader from '../../../layouts/Loader.vue'
	
	export default {
		props: ['round', 'gameId'],
		data () {
			return {
				panel: [0]
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			company () {
				return this.$store.getters.company
			},
			//from summary last round
			channelsSales () {
				return this.$store.getters.channelsSales
			},
			toUpgrade () {
				let resArr = []
				const upgraded = this.$store.getters.toUpgrade
				if (upgraded) {//upgraded of this company
					resArr = upgraded.filter(item => item.company === this.company)
				}
				return resArr
			},
			//this round
			products () {
				return this.$store.getters.products
			},
			models () {
				return this.$store.getters.models
			},
			myChannelsSales () {//only prev round models + upgraded last round
				const resArr = []
				//учитываем модели, которые в прошлом раунде были до upgrade
				let uModels = []
				if (this.toUpgrade.length) {
					this.toUpgrade.forEach(item => {
						uModels = uModels.concat(item.models)
					})
				}
				uModels = uModels.concat(this.models)

				this.channelsSales.forEach(item => {
					const my = uModels.find(mod => mod.modelId === item.modelId)
					if (my) {
						resArr.push(item)
					}
				})
				return resArr
			},
			prevProducts () {//only prev round products
				const resArr = []
				
				if (this.myChannelsSales.length) {

					this.products.forEach(product => {
						let models = product.models
						
						const isUpgrade = this.toUpgrade.find(item => item.id === product.id)
						if (isUpgrade) {
							models = models.concat(isUpgrade.models)
						}

						const prevRoundModels = []
						models.forEach(model => {
							const matchModel = this.myChannelsSales.find(mod => mod.modelId === model.modelId)
							if (matchModel) {
								prevRoundModels.push(model)
							}
						})

						if (prevRoundModels.length) {
							resArr.push({
								trademark: product.trademark,
								id: product.id,
								models: prevRoundModels
							})
						}
					})
				}
				//console.log(resArr)
				return resArr
			},
			channels () {
				return this.$store.getters.channels
			},
			prevChannels () {
				const resArr = []
				if (this.channels.length) {
					this.channels.forEach(channel => {
						const match = this.myChannelsSales.find(item => item.channel === channel.name )
						const inResArr = resArr.find(item => item.name === channel.name)
						if(match && !inResArr) {
							resArr.push(channel)
						}
					})
				}
				return resArr
			},
			selfChannels () {
				return this.prevChannels.filter(chan => chan.type < 3)
			},
			independentChains () {
				return this.prevChannels.filter(chan => chan.type > 2)
			}
		},
		methods: {
			//format in numeral
			format (param) {
				return numeral(param).format('0,0[.]0')//
			},
			name (model) {
				return model.split(' - ')[1] //trademark cutted name
			},
			sortArrObjs (arr) {
				//sort models
				arr.sort((prev, next) => {
					let p = prev.model.toLowerCase()
					let n = next.model.toLowerCase()
					if (p < n) return -1;
					if (p > n) return 1;
					return 0;
				})
				return arr
			},
			sortedModels(models) {
				return this.sortArrObjs(models)
			},
			modelSales(channel, model) {
				const match = this.channelsSales.find(item => (item.modelId === model.modelId
					&& item.channel == channel.name))
				if (match) return match.sales
				else return 0
			},
			yearSales (model) {
				const res = this.prevChannels.reduce((sum, channel) => {
					return sum+= this.modelSales(channel, model)
				}, 0)
				return res
			},
			trademarkSales(trademark, chan) {
				const brand = this.prevProducts.find(item => item.trademark === trademark)
				const models = brand.models
				const res = models.reduce((sum, model) => {
					return sum+= this.modelSales(chan, model)
				}, 0)
				return res
			},
			yearTrademarkSales(trademark) {
				const res = this.prevChannels.reduce((sum, channel) => {
					return sum+= this.trademarkSales(trademark, channel)
				}, 0)
				return res
			},
			channelSales (channel) {
				//учитываем модели, которые в прошлом раунде были до upgrade
				let uModels = []
				if (this.toUpgrade.length) {
					this.toUpgrade.forEach(item => {
						uModels = uModels.concat(item.models)
					})
				}
				uModels = uModels.concat(this.models)

				let sales = 0
				uModels.forEach(model => {
					sales+= this.modelSales(channel, model)
				})
				return sales
			},
			yearChannelsSales () {
				const arr = []
				this.prevChannels.forEach(channel => {
					arr.push(this.channelSales(channel))
				})
				return arr.reduce((sum,item) => sum + item)
			}
		},
		components: {Loader}
	}
</script>